export default __webpack_public_path__ + "static/media/sanaPanel.304979f5.png";